import MatchList from 'components/MatchList';
import PillTabList from 'components/PillTabList';
import WidgetTvProgram from 'components/WidgetTvProgram';
import useCompetitions from 'hooks/useCompetitions';
import React, {FC, Ref, RefObject, useEffect, useMemo} from 'react';
import {createPortal} from 'react-dom';

import {Tabs, TabPanel} from 'react-tabs';
import {groupMatchesByCompetition} from 'utils/matchFns';

import {MatchSimple, Sport, TVProgramEvent} from 'utils/types';

import './styles.scss';

const MatchcenterScoreboardPanel: FC<{
  match: MatchSimple;
  root: HTMLElement | null;
}> = ({
  match: {_id, sportEventSlug, competition, teams, score, matchStatus},
  root,
}: {
  match: MatchSimple;
  root: HTMLElement | null;
}) =>
  root &&
  createPortal(
    <a href={`/matchcenter/${sportEventSlug}/${_id}`} className="MatchcenterScoreboardPanel">
      <h1 className="MatchcenterScoreboardPanel__header">{competition}</h1>
      <div className="MatchcenterScoreboardPanel__scoreboard">
        <h2 className="MatchcenterScoreboardPanel__teamName">{teams[0].shortName}</h2>
        <img
          className="MatchcenterScoreboardPanel__teamLogo"
          src={teams[0].imageUrl}
          width="40"
          height="40"
          alt={teams[0].name}
        />
        <span className="MatchcenterScoreboardPanel__teamScore">{score[0]}</span>
        <span className="MatchcenterScoreboardPanel__matchStatus">{matchStatus}</span>
        <span className="MatchcenterScoreboardPanel__teamScore">{score[1]}</span>
        <img
          className="MatchcenterScoreboardPanel__teamLogo"
          src={teams[1].imageUrl}
          width="40"
          height="40"
          alt={teams[1].name}
        />
        <h2 className="MatchcenterScoreboardPanel__teamName">{teams[1].shortName}</h2>
      </div>
    </a>,
    root
  );

export default React.memo(MatchcenterScoreboardPanel);
